import { useReducer } from 'react'

function reducer(state, action) {
  const actions = {
    complete: ({ idx, isWin }) => {
      let newScenes = state.scenes.map((scene, index) => {
        if (index === idx) {
          return { ...scene, complete: true, isWin: isWin }
        } else {
          return scene
        }
      })
      let wonScenes = isWin ? state.wonScenes + 1 : state.wonScenes
      return {
        ...state,
        scenes: newScenes,
        currentSceneCompleted: true,
        wonScenes: wonScenes,
      }
    },
    started: ({ idx }) => {
      if (idx === 0) {
        state.onStepStarted()
      }
      let newScenes = state.scenes.map((scene, index) => {
        if (index === idx) {
          return { ...scene, started: true }
        } else {
          return scene
        }
      })

      return {
        ...state,
        scenes: newScenes,
        currentScene: idx,
      }
    },
    currentSceneCompleted: ({ bool }) => {
      return {
        ...state,
        currentSceneCompleted: bool,
      }
    },
    nextScene: () => {
      return {
        ...state,
        currentScene: state.currentScene + 1,
        currentSceneCompleted: false,
      }
    },
  }
  return actions[action.type](action)
}

const useScenes = ({ scenes, analytics }) => {
  const { onStepFinished, onStepStarted, onNextScene } = analytics || {}

  const [state, dispatch] = useReducer(reducer, {
    scenes: scenes.map(scene => ({
      ...scene,
      complete: false,
      started: false,
    })),
    onStepFinished,
    onStepStarted,
    currentScene: 0,
    currentSceneCompleted: false,
    wonScenes: 0,
    totalScenes: scenes.length,
  })

  const completeScene = (idx, isWin) => {
    dispatch({ type: 'complete', idx, isWin })

    if (idx === state.scenes.length - 1) {
      onStepFinished()
    }
  }

  const startScene = idx => {
    dispatch({ type: 'started', idx })
  }

  const setCurrentSceneStatus = bool => {
    dispatch({
      type: 'currentSceneCompleted',
      bool,
    })
  }

  const nextScene = () => {
    onNextScene({ currentScene: state.currentScene })
    dispatch({
      type: 'nextScene',
    })
  }

  return {
    state,
    currentScene: state.currentScene,
    currentSceneCompleted: state.currentSceneCompleted,
    completeScene,
    startScene,
    setCurrentSceneStatus,
    nextScene,
    wonScenes: state.wonScenes,
    totalScenes: state.totalScenes,
  }
}

export { useScenes }
